import { render, staticRenderFns } from "./PacketizationDiagramContainer.vue?vue&type=template&id=dca5e1ce&"
import script from "./PacketizationDiagramContainer.vue?vue&type=script&lang=ts&"
export * from "./PacketizationDiagramContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports